import { logPermissionDecision } from '@/features/permissions/permissionDiagnostics.js'
import { usePermission } from '@/features/permissions/usePermission.js'

export function usePermissionItemFilter(surface = 'admin') {
  const { decision } = usePermission({ surface })

  function filterItem(item) {
    if (!item) return null

    const children = (item.children ?? []).map(filterItem).filter(Boolean)
    const action = item.permissionAction
    const anyActions = item.permissionAnyActions ?? []

    if (!action && !anyActions.length) {
      return {
        ...item,
        children,
      }
    }

    const itemDecisions = action
      ? [
          decision(action, {
            surface,
            route: item.to,
          }),
        ]
      : anyActions.map(anyAction =>
          decision(anyAction, {
            surface,
            route: item.to,
          }),
        )

    const itemDecision = itemDecisions.find(candidate => candidate.allowed) ?? itemDecisions[0]

    if (!itemDecision.allowed) {
      logPermissionDecision('navigation_hidden', itemDecision, {
        label: item.label,
        route: item.to,
      })
      return null
    }

    return {
      ...item,
      children,
    }
  }

  function filterItems(items) {
    return items.map(filterItem).filter(Boolean)
  }

  return {
    filterItems,
  }
}
